import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  "data-testid": "list-benchmark-page",
  class: "page list-benchmark-page"
}
const _hoisted_2 = {
  key: 1,
  class: "d-flex align-center justify-center pt-5 mt-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_layout = _resolveComponent("v-layout")!
  const _component_AppTable = _resolveComponent("AppTable")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_AppLoader = _resolveComponent("AppLoader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_container, { fluid: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_layout, { class: "mt-4 pa-0" }, {
          default: _withCtx(() => [
            _cache[4] || (_cache[4] = _createElementVNode("div", { style: {"align-self":"center"} }, [
              _createElementVNode("h2", { class: "section-title" }, [
                _createElementVNode("span", null, "ALL Benchmarks")
              ])
            ], -1)),
            _createVNode(_component_v_layout, {
              "align-end": "",
              class: "py-2 justify-end"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'dashboard.benchmark.add' })))
                }, {
                  default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                    _createElementVNode("span", null, "Add New Benchmark", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (_ctx.benchmarks)
          ? (_openBlock(), _createBlock(_component_v_card, {
              key: 0,
              class: "mt-4"
            }, {
              default: _withCtx(() => [
                (_ctx.benchmarks && _ctx.benchmarks.length)
                  ? (_openBlock(), _createBlock(_component_AppTable, {
                      key: 0,
                      "table-data": _ctx.tableData,
                      onViewItemClick: _cache[1] || (_cache[1] = (e) => _ctx.getBenchmarkDetails(e)),
                      disablePagination: true
                    }, null, 8, ["table-data"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (!_ctx.benchmarks)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_v_progress_circular, {
                indeterminate: "",
                color: "grey"
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.showCurrentBenchmark,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showCurrentBenchmark) = $event)),
      width: "50%"
    }, {
      default: _withCtx(() => [
        (_ctx.currentBenchmark.id)
          ? (_openBlock(), _createBlock(_component_v_card, {
              key: 0,
              class: "pa-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.currentBenchmark.id) + " : " + _toDisplayString(_ctx.currentBenchmark.name), 1),
                    _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1))
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentBenchmark, (value, prop) => {
                      return (_openBlock(), _createElementBlock("div", { key: prop }, _toDisplayString(prop) + " : " + _toDisplayString(value), 1))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_v_card, { key: 1 }, {
              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                _createTextVNode(" LOADING... ", -1)
              ]))]),
              _: 1
            }))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_ctx.fetchingBenchmarks)
      ? (_openBlock(), _createBlock(_component_AppLoader, { key: 0 }))
      : _createCommentVNode("", true)
  ]))
}